import React from "react";
import { FaTimes } from "react-icons/fa";
import { GeneralTranslation } from "../../Translations/GeneralTranslation";
import { useLanguage } from "../LanguageContext";
import { ConfirmationModalProps, Language } from "../../Types/types";

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  label,
}) => {
  const { language } = useLanguage();
  const t = GeneralTranslation[language as Language];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 bg-[#586EDFCC]">
      <div className="bg-white rounded-lg shadow-lg p-4 w-full max-w-lg relative mx-2 sm:mx-auto dark:bg-darkSecondaryBackground">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500"
        >
          <FaTimes />
        </button>
        <div className="flex justify-center items-center mb-4 mt-2" />
        <p className="mb-6 text-center">{label}</p>
        <div className="flex justify-end space-x-2 mt-4 sm:mt-6">
          <button
            type="button"
            className="bg-gray-300 text-gray-700 px-3 py-2 rounded font-medium shadow-sm dark:bg-white dark:text-black"
            onClick={onClose}
          >
            {t.cancel}
          </button>
          <button
            type="button"
            className="bg-red-500 text-white px-3 py-2 rounded font-medium shadow-sm"
            onClick={onConfirm}
          >
            {t.confirm}
          </button>
        </div>
      </div>
    </div>
  );
};
